type BaseObject = {
  id: string;
};

function isItemInCollection<T extends BaseObject>(
  option: T,
  options: T[],
  isOptionEqualToValue?: (option: T, value: T) => boolean,
) {
  return isOptionEqualToValue
    ? options.some((s) => isOptionEqualToValue(option, s))
    : options.some((s) => s.id === option.id);
}

export function handleSelectionChangeOnPaginatedData<T extends BaseObject>(
  selected: T[],
  selectedOnPage: T[],
  currentPage: T[],
  isOptionEqualToValue?: (option: T, value: T) => boolean,
) {
  // Select every item that are coming with the change event,
  // but not part of the currently selected items
  const selectedItems = currentPage.filter(
    (answer) =>
      isItemInCollection(answer, selectedOnPage, isOptionEqualToValue) &&
      !isItemInCollection(answer, selected, isOptionEqualToValue),
  );

  // Select every item that are not in the currently emitted selected items,
  // but are on the currently displayed page and are currently stored in the selected items.
  // If we don't filter for current page, this would remove
  // every item that is not on the current page.
  const deselectedItems = selected.filter(
    (answer) =>
      !isItemInCollection(answer, selectedOnPage, isOptionEqualToValue) &&
      isItemInCollection(answer, currentPage, isOptionEqualToValue),
  );

  // Remove every deselected item from the selected items
  const selectedItemsWithoutDeselected = selected.filter(
    (answer) =>
      !isItemInCollection(answer, deselectedItems, isOptionEqualToValue),
  );

  // The newly selected items are the ones that remain after removing the
  // deselected items and adding the newly selected items
  return [...selectedItems, ...selectedItemsWithoutDeselected];
}
